

import { LightningElement, api } from 'lwc';

function arcForPercent(percent) {
    const pct = Math.max(0, Math.min(100, percent)); // clamp 0–100
    const radius = 1;

    // Convert % to radians
    const angle = (pct / 100) * 2 * Math.PI;

    // Start of arc (point at 1,0 on unit circle)
    const startX = 1;
    const startY = 0;

    // End of arc
    const endX = Math.cos(angle);
    const endY = Math.sin(angle);

    // SVG arc flags
    const largeArcFlag = angle > Math.PI ? 1 : 0;
    const sweepFlag = 1; // clockwise

    // Build path
    return `
        M ${startX} ${startY}
        A ${radius} ${radius} 0 ${largeArcFlag} ${sweepFlag} ${endX} ${endY}
        L 0 0
    `.trim();
}

export default class sldsProgressRing extends LightningElement {
    @api 
    set color(val) {
        this._color = val;
        this._applyVarsDirect('--progress-ring-color', val);
    }
    get color() {
        return this._color;
    }

    _progressContent;
    @api 
    set progressContent(val) {
        this._progressContent = val;
    }
    get progressContent() {
        return this._progressContent;
    }

    _progressPct = 0;
    @api 
    set progressPct(val) {
        if (val || val === 0) {
            const numVal = Number(val);
            if (!isNaN(numVal)) {
                this._progressPct = numVal;
            }
        }
    } 
    get progressPct() {
        return this._progressPct;
    }

    @api ariaLabel = 'Progress'; // optional a11y label

    // Shared angle for both arc and head
    get _clampedPercent() {
        return Math.max(0, Math.min(100, this._progressPct));
    }

    get _angle() {
        return (this._clampedPercent / 100) * 2 * Math.PI;
    }

    get arcPath() {
        return arcForPercent(this._clampedPercent);
    }

    // SLDS positions the head at about 70% of the ring radius
    get _headRadius() {
        return 0.7; // matches SLDS geometry
    }

    get headX() {
        return this._headRadius * Math.cos(this._angle);
    }

    get headY() {
        return this._headRadius * Math.sin(this._angle);
    }


    get pctLabel() {
        return `${this._progressPct}% complete`;
    }

    // Apply Styles to the host 👉 Can pass 1.Array of Arrays   2.Array of Object   3.Strings
    _applyVarsDirect(cssVar, varStyle=null) {

        // Check that CSS var starts with '--' and has a non-null stlye 
        const isValid = (cssVarP, varStyleP) => {
            return typeof cssVarP === 'string' && 
                typeof varStyleP === 'string' &&
                cssVarP?.startsWith('--') && 
                varStyleP;
        }



        const el = this.template.host;
        
        if (Array.isArray(cssVar)) {
            // Handle Array of vars
            cssVar.forEach(hostVar => {
                if (Array.isArray(hostVar) && isValid(hostVar[0], hostVar[1])) {
                    // Handle Array structure  (CSS var at index 0)
                    el.style.setProperty(hostVar[0], hostVar[1]);
                } else if (typeof hostVar === 'object' && isValid(hostVar.cssVar, hostVar.varStyle)) {
                    // Handle Object structure (cssVar & varStyle keys)
                    el.style.setProperty(hostVar.cssVar, hostVar.varStyle)
                }
            });
        } else if (isValid(cssVar, varStyle)) {
            // Handle string arguments
            el.style.setProperty(cssVar,  varStyle);
        }
    }
}